import { render, staticRenderFns } from "./XhFiles.vue?vue&type=template&id=10fbd6f5&scoped=true&"
import script from "./XhFiles.vue?vue&type=script&lang=js&"
export * from "./XhFiles.vue?vue&type=script&lang=js&"
import style0 from "./XhFiles.vue?vue&type=style&index=0&id=10fbd6f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fbd6f5",
  null
  
)

component.options.__file = "XhFiles.vue"
export default component.exports